import { render } from "./PurchaseCredits.vue?vue&type=template&id=0f2d06d2&scoped=true"
import script from "./PurchaseCredits.vue?vue&type=script&lang=js"
export * from "./PurchaseCredits.vue?vue&type=script&lang=js"

import "./PurchaseCredits.vue?vue&type=style&index=0&id=0f2d06d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2d06d2"]])

export default __exports__